<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@eventDetails">Event Details</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <div class="cards-container">
    <mat-card class="icons-card mb-16">
      <mat-card-content class="d-flex">
        <mat-icon class="mr-10" color="accent" i18n="@@eventIcon">event</mat-icon>
        <div class="w-90">
          <div class="mb-12 event-name" matTooltip ellipsisTooltip>{{event.name}}</div>
          <div class="d-flex align-items-center  mat-caption mb-10">
            <mat-icon class="mr-10" i18n="@@descriptionIcon">description</mat-icon>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{event.description}}</div>
          </div>
          <div class="d-flex align-items-center  mat-caption mb-10">
            <mat-icon class="mr-10" i18n="@@dateRangeIcon">date_range</mat-icon>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{event.startDate}}  - {{event.endDate}}</div>
          </div>
          <div class="d-flex align-items-center  mat-caption mb-10">
            <mat-icon class="mr-10" i18n="@@placeIcon">place</mat-icon>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{event.country}}/{{event.city}}/{{event.venue}}</div>
          </div>
          <div class="d-flex align-items-center  mat-caption">
            <mat-icon class="mr-10" i18n="@@boothIcon">store</mat-icon>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{event.booth}}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-expansion-panel class="mb-16">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@products">Products</mat-panel-title>
      </mat-expansion-panel-header>
      @for (product of event.products; track product) {
        <div class="mat-caption mb-28" matTooltip ellipsisTooltip>{{product.name}}</div>
      }
    </mat-expansion-panel>
    <mat-expansion-panel class="mb-16">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@departments">Departments</mat-panel-title>
      </mat-expansion-panel-header>
      @for (department of event.departments; track department) {
        <div class="mat-caption mb-28" matTooltip ellipsisTooltip>{{department.name}}</div>
      }
    </mat-expansion-panel>
    <!-- <mat-card *ngIf="authService.getUserData().type === utils.userTypes.Distributor && event.usedOnMobile && selected === 'usedOnMobile'" class="used-on-mobile">
    <div i18n="@@usedOnMobile" class="mat-subheading-2">Use on mobile</div>
    <mat-checkbox [checked]="usedOnMobile" (change)="usedOnMobileToggle($event)" color="accent"></mat-checkbox>
  </mat-card> -->
  </div>
</mat-dialog-content>